// src/settings/UpdateMobile.tsx
import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../config';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

const UpdateMobile: React.FC = () => {
  const navigate = useNavigate();
  const [currentMobile, setCurrentMobile] = useState('');
  const [newMobile, setNewMobile] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      navigate('/login');
      return;
    }

    fetch(`${API_BASE_URL}/auth/me`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setCurrentMobile(data.user.mobile || '');
        } else {
          navigate('/login');
        }
      })
      .catch(() => navigate('/login'));
  }, [navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newMobile.match(/^\d{10}$/)) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Mobile Number',
        text: 'Please enter a valid 10-digit mobile number.',
        customClass: { confirmButton: 'bg-indigo-600 text-white px-4 py-2 rounded' },
      });
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/auth/update-mobile`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
        body: JSON.stringify({ mobile: newMobile }),
      });

      const data = await res.json();
      if (res.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Mobile Updated',
          text: data.message,
          customClass: { confirmButton: 'bg-indigo-600 text-white px-4 py-2 rounded' },
        });
        setCurrentMobile(newMobile);
        setNewMobile('');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: data.error || 'Something went wrong.',
          customClass: { confirmButton: 'bg-red-500 text-white px-4 py-2 rounded' },
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-20 p-6 bg-white rounded shadow">
      <h2 className="text-xl font-bold mb-6 text-center text-indigo-700">Update Mobile Number</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="text-sm text-gray-600">Current Mobile</label>
          <input
            type="text"
            value={currentMobile}
            disabled
            className="w-full p-2 border bg-gray-100 rounded"
          />
        </div>
        <div>
          <label className="text-sm text-gray-600">New Mobile</label>
          <input
            type="text"
            value={newMobile}
            onChange={(e) => setNewMobile(e.target.value)}
            className="w-full p-2 border rounded"
            required
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-indigo-600 text-white py-2 rounded hover:bg-indigo-700"
        >
          {loading ? 'Updating...' : 'Update Mobile'}
        </button>
      </form>
    </div>
  );
};

export default UpdateMobile;
